<template>
  <div class="inner_page about_page">
    <pageHeader createBtn />
    <div class="inner_page_cont">
      <h1>About Gif Banana</h1>
      <section class="inner_page_body">
        <p>Gif Banana allows you to express yourself and to make your friends laugh by giving you a way to create fun quizes that can be easily shared on social media.</p>
        <p>These funny quizes you create are animated images that contain either words or emoji’s.</p>
        <h2>A typical use case for these quizes</h2>
        <ol>
          <li>Ask a funny question like “Which emoji are you?”.</li>
          <li>Specify funny answer as emoji’s or text.</li>
          <li>Share quiz’s gif with your friends.</li>
          <li>Ask your friends to take a screenshot once they open the quiz.</li>
          <li>You and your friends should share these screenshots to see each other’s funny results!</li>
        </ol>
        <h2>Example</h2>
        <gifCard
            postId="-MHweq09p8YIkCkbeOt8"
        />
        <hr>
        <p>
          Gif Banana is not another Silicon Valley product, it’s a product of love, passion, and creativity. <br>
          Designed and coded with lots of 💕 love by Mahdi Farra.
        </p>
        <hr>
        <div class="credits_cont">
          <p>Great thanks to Ashraf Samhouri for suggesting the initial idea,
            and a big shoutoud to everyone who helped me along the way:
            <span v-for="(name, index) in credits" :key="index">
              {{name}}<span v-if="index != Object.keys(credits).length - 1">, </span>
            </span>.
          </p>
          <hr>
          <p>Proudly built using Vuejs and hosted on Netlify</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import pageHeader from '@/components/pageHeader'
  import gifCard from '@/components/gifCard'
  
export default {
  name: 'About',
  components: {
    pageHeader,
    gifCard,
  },
  data() {
    return {
      loadingSkeletonShown: true,
      credits: [
        'Nour Saud',
        'Mohammad Jaber',
        'Saadi Shahin',
        'Adrian Florescu',
        'Jibran',
        'Kumail Hunaid',
        'Alvaro Hurtado',
        'Pedro Marques',
        'Jason Mari',
        'Arjen van Reeven',
        'Camiel Koomen',
        'Matias Brasca',
        'Michael Rurka',
        'Kolton Gagnon',
        'Philip Rurka',
      ]
    }
  },
  methods: {
  },
  mounted() {
     window.scrollTo(0,0);
  },
}
</script>